import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFarmLandUseChanges, setFarmLandUseChangesAdmin } from "services";

import { footprintingFarmPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_FARM_LAND_USE_CHANGE_USAGE } from "consts";

import { LandUseChangeRequestPayload } from "models";

export const useMutateFarmLandUseChanges = (farmId: string, year: number, range: number, payload: LandUseChangeRequestPayload, primaryDataId?: string) => {
  const queryClient = useQueryClient();
  const isAdmin = getEnvironment().admin;

  const queryFn = isAdmin ? setFarmLandUseChangesAdmin : setFarmLandUseChanges;

  return useMutation(
    {
      mutationKey: [FOOTPRINTING_FARM_LAND_USE_CHANGE_USAGE, farmId, year, range, isAdmin],
      mutationFn: () => queryFn(farmId, payload, year, range),
      onSuccess: async () => {
        invalidateAndRefecthQueries(queryClient, [
          [FOOTPRINTING_FARM_LAND_USE_CHANGE_USAGE, farmId, year, range, isAdmin],
          ...footprintingFarmPrimaryQueryKeys(primaryDataId ?? "", farmId, year, isAdmin),
        ]);
      },
    },
    queryClient
  );
};
